var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 37.4,
    viewBox: "0 0 34 37.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M23.8,0a1.7,1.7,0,0,1,1.688,1.5l.012.2V3.4h3.4a5.1,5.1,0,0,1,5.092,4.8L34,8.5V32.3a5.1,5.1,0,0,1-5.1,5.1H5.1A5.1,5.1,0,0,1,0,32.3H0V8.5A5.1,5.1,0,0,1,5.1,3.4H8.5V1.7a1.7,1.7,0,0,1,3.388-.2l.012.2V3.4H22.1V1.7A1.7,1.7,0,0,1,23.8,0Zm6.8,17H3.4V32.3a1.7,1.7,0,0,0,1.5,1.688L5.1,34H28.9a1.7,1.7,0,0,0,1.7-1.7h0ZM8.5,6.8H5.1A1.7,1.7,0,0,0,3.4,8.5h0v5.1H30.6V8.5a1.7,1.7,0,0,0-1.5-1.688L28.9,6.8H25.5V8.5a1.7,1.7,0,0,1-3.388.2L22.1,8.5V6.8H11.9V8.5a1.7,1.7,0,0,1-3.388.2L8.5,8.5Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.186eea12c436e8bd1d5e0194be251204.svg";
export { ForwardRef as ReactComponent };